import { render, staticRenderFns } from "./transversalcosts.pug?vue&type=template&id=84641d92&lang=pug&"
import script from "./transversalcosts.js?vue&type=script&lang=js&"
export * from "./transversalcosts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84641d92')) {
      api.createRecord('84641d92', component.options)
    } else {
      api.reload('84641d92', component.options)
    }
    module.hot.accept("./transversalcosts.pug?vue&type=template&id=84641d92&lang=pug&", function () {
      api.rerender('84641d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/transversalcosts/index.vue"
export default component.exports